export default {
  baseURL: 'https://miib.levantandoacristo.cl/api',
  wpSiteId: '8',
  storage: 'https://d3sl5ozezaww6i.cloudfront.net/',
  video_cdn: 'https://d30nqtorei283e.cloudfront.net/',
  s3Url: 'https://s3.amazonaws.com/miit.levantandoacristo.cl/',
  wsUrl: 'https://miib.levantandoacristo.cl:3001',
  siteUrl: 'https://miib.cl',
}

export const firebaseConfig = {
  apiKey: 'AIzaSyBxlkfDGkMVLjBPWyoNf3IFGLvFCnabhD4',
  authDomain: 'miit-dd22f.firebaseapp.com',
  databaseURL: 'https://miit-dd22f.firebaseio.com',
  projectId: 'miit-dd22f',
  storageBucket: 'miit-dd22f.appspot.com',
  messagingSenderId: '937104958210',
  appId: '1:937104958210:web:f15266b1767caab0c3981b',
}

export const vapidKey =
  'BH37OUT8Ax7d0ODvloj39hd78XyhHFSIcn4259jQnh5PNM895fUn9Hlhi7zDaIqUf-ENwEjk3M7NFxJUNSk5d54'

export const bugsnagKey = '6e96241db5ef04d57aad1b0cd53c836c'
